import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
export default new Router({
  routes: [
    {
      path:'/',
      redirect:'/index'
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('../views/index.vue'),//首页
      meta:{
        title: 'DADI CINEMA',
      }
    },
    {
      path: '/login/index',
      name: '/login/index',
      component: () => import('../views/login/index.vue'),//登录页
      meta:{
        title: 'DADI CINEMA'
      }
    },
    {
      path: '/login/bind',
      name: '/login/bind',
      component: () => import('../views/login/bind.vue'),//登录页第三方绑定
      meta:{
        title: 'DADI CINEMA'
      }
    },
    {
      path: '/film/index',
      name: '/film/index',
      component: () => import('../views/film/index.vue'),//电影列表页
      meta:{
        title: 'DADI CINEMA',
        keepAlive: true,
      }
    },
    {
      path: '/film/coming',
      name: '/film/coming',
      component: () => import('../views/film/coming.vue'),//电影即将上映列表页
      meta:{
        title: 'DADI CINEMA'
      }
    },
    {
      path: '/film/detail',
      name: '/film/detail',
      component: () => import('../views/film/detail.vue'),//电影详情页
      meta:{
        title: 'DADI CINEMA'
      }
    },
    {
      path: '/tickets/map',
      name: '/tickets/map',
      component: () => import('../views/tickets/map.vue'),//影院页面
      meta:{
        title: 'DADI CINEMA',
      }
    },
    {
      path: '/tickets/detail',
      name: '/tickets/detail',
      component: () => import('../views/tickets/detail.vue'),//影院详情页
      meta:{
        title: 'DADI CINEMA'
      }
    },
    {
      path: '/tickets/choose',
      name: '/tickets/choose',
      component: () => import('../views/tickets/choose.vue'),//电影选坐
      meta:{
        title: 'DADI CINEMA'
      }
    },
    {
      path: '/tickets/choose_seat',
      name: '/tickets/choose_seat',
      component: () => import('../views/tickets/choose_seat.vue'),//电影选坐-选坐
      meta:{
        title: 'DADI CINEMA'
      }
    },
    {
      path: '/tickets/choose_order',
      name: '/tickets/choose_order',
      component: () => import('../views/tickets/choose_order.vue'),//电影选坐——确认
      meta:{
        title: 'DADI CINEMA'
      }
    },
    {
      path: '/tickets/shop_order',
      name: '/tickets/shop_order',
      component: () => import('../views/tickets/shop_order.vue'),//食品订单——确认
      meta:{
        title: 'DADI CINEMA'
      }
    },
    {
      path: '/tickets/choose_order_confirm',
      name: '/tickets/choose_order_confirm',
      component: () => import('../views/tickets/choose_order_confirm.vue'),//电影选坐——确认
      meta:{
        title: 'DADI CINEMA'
      }
    },
    {
      path: '/tickets/choose_sell',
      name: '/tickets/choose_sell',
      component: () => import('../views/tickets/choose_sell.vue'),//电影选坐——卖品选择
      meta:{
        title: 'DADI CINEMA'
      }
    },
    {
      path: '/tickets/choose_pay',
      name: '/tickets/choose_pay',
      component: () => import('../views/tickets/choose_pay.vue'),//电影选坐——支付
      meta:{
        title: 'DADI CINEMA'
      }
    },
    {
      path: '/sell/index',
      name: '/sell/index',
      component: () => import('../views/sell/index.vue'),//卖品页面
      meta:{
        title: 'DADI CINEMA',
        keepAlive: true,
      }
    },
    {
      path: '/sell/detail',
      name: '/sell/detail',
      component: () => import('../views/sell/detail.vue'),//卖品详情页
      meta:{
        title: 'DADI CINEMA'
      }
    },
    {
      path: '/card/index',
      name: '/card/index',
      component: () => import('../views/card/index.vue'),//会员卡页面
      meta:{
        title: 'DADI CINEMA'
      }
    },
    {
      path: '/card/detail',
      name: '/card/detail',
      component: () => import('../views/card/detail.vue'),//会员卡详情页
      meta:{
        title: 'DADI CINEMA'
      }
    },
    {
      path: '/card/card_buy',
      name: '/card/card_buy',
      component: () => import('../views/card/card_buy.vue'),//会员卡购买
      meta:{
        title: 'DADI CINEMA'
      }
    },
    {
      path: '/card/card_pay',
      name: '/card/card_pay',
      component: () => import('../views/card/card_pay.vue'),//会员卡支付
      meta:{
        title: 'DADI CINEMA'
      }
    },
    {
      path: '/other/theater',
      name: '/other/theater',
      component: () => import('../views/other/theater.vue'),//影院选择
      meta:{
        title: 'DADI CINEMA'
      }
    },
    {
      path: '/other/U',
      name: '/other/U',
      component: () => import('../views/other/U.vue'),//U+卡详情
      meta:{
        title: 'DADI CINEMA',
        keepAlive: true,
      }
    },
    {
      path: '/other/search',
      name: '/other/search',
      component: () => import('../views/other/search.vue'),//搜索
      meta:{
        title: 'DADI CINEMA'
      }
    },
    {
      path: '/other/FAQ',
      name: '/other/FAQ',
      component: () => import('../views/other/FAQ.vue'),//FAQ
      meta:{
        title: 'DADI CINEMA',
        keepAlive: true,
      }
    },
    {
      path: '/other/activity',
      name: '/other/activity',
      component: () => import('../views/other/activity.vue'),//历史活动列表
      meta:{
        title: 'DADI CINEMA',
        keepAlive: true,
      }
    },
    {
      path: '/other/activity_detail',
      name: '/other/activity_detail',
      component: () => import('../views/other/activity_detail.vue'),//历史活动列表 详情
      meta:{
        title: 'DADI CINEMA'
      }
    },
    {
      path: '/event/index',
      name: '/event/index',
      component: () => import('../views/event/index.vue'),     //event页面
      meta:{
        title: 'DADI CINEMA',
        keepAlive: true,
      }
    },
    {
      path: '/experience/index',
      name: '/experience/index',
      component: () => import('../views/experience/index.vue'),     //experience页面
      meta:{
        title: 'DADI CINEMA',
        keepAlive: true,
      }
    },

    {
      path: '/member',
      name: '/member',
      component: () => import('../views/member/index.vue'),//会员中心
      meta:{
        title: 'DADI CINEMA'
      },
      children: [
        {
          path: 'index',
          name: 'index',
          meta:{
            title: 'DADI CINEMA'
          },
          component: () => import('../views/member/personal.vue'),//会员中心
        },
        {
          path: 'order',
          name: 'order',
          component: () => import('../views/member/order.vue'),//会员中心 订单
          meta:{
            title: 'DADI CINEMA'
          }
        },
        {
          path: 'order_detail',
          name: 'order_detail',
          component: () => import('../views/member/order_detail.vue'),//会员中心 订单详情
          meta:{
            title: 'DADI CINEMA'
          }
        },
        {
          path: 'coupon',
          name: 'coupon',
          component: () => import('../views/member/coupon.vue'),//会员中心 优惠券
          meta:{
            title: 'DADI CINEMA'
          }
        },
        {
          path: 'integral',
          name: 'integral',
          component: () => import('../views/member/integral.vue'),//会员中心 积分
          meta:{
            title: 'DADI CINEMA'
          }
        },
        {
          path: 'message',
          name: 'message',
          component: () => import('../views/member/message.vue'),//会员中心 消息中心
          meta:{
            title: 'DADI CINEMA'
          }
        },
        {
          path: 'wantsee',
          name: 'wantsee',
          component: () => import('../views/member/wantsee.vue'),//会员中心 我想看的
          meta:{
            title: 'DADI CINEMA'
          }
        },
        {
          path: 'card',
          name: 'card',
          component: () => import('../views/member/card.vue'),//会员中心 会员卡
          meta:{
            title: 'DADI CINEMA'
          }
        },
        {
          path: 'faq',
          name: 'faq',
          component: () => import('../views/member/faq.vue'),//会员中心 常见问题解答
          meta:{
            title: 'DADI CINEMA'
          }
        },
        {
          path: 'pwd',
          name: 'pwd',
          component: () => import('../views/member/pwd.vue'),//会员中心 找回密码
          meta:{
            title: 'DADI CINEMA'
          }
        },
      ]
    },
   
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js